// Auth domain types — seed-backend contract (snake_case wire), per Schema_Specification Section 3.2.

export type UserRole = 'Admin' | 'Manager' | 'Operator' | 'Technician'

export interface User {
  id: string
  tenant_id: string | null
  full_name: string | null
  email: string | null
  phone: string | null
  phone_e164: string | null
  preferred_language: string | null
  role: UserRole
  roles?: UserRole[]
  permissions?: string[]
  title?: string | null
  avatar?: string | null
  is_active: boolean
  last_login_at: string | null
  date_of_birth: string | null
  created_at: string
  updated_at: string
}

export interface AuthTokens {
  user: User
  token_type: 'Bearer'
  access_token: string
  access_token_expires_at: string
  refresh_token: string
  refresh_token_expires_at: string
}

export interface OtpResult {
  token: string
  expires_at: string
}

export interface ResetToken {
  token: string
}

export interface LoginRequest {
  email: string
  password: string
  recaptcha_token?: string
}

export interface RegisterRequest {
  email: string
  phone?: string
  full_name: string
  recaptcha_token?: string
}

export interface VerifyOtpRequest {
  token: string
  otp: string
}

export interface SetupPasswordRequest {
  token: string
  password: string
  password_confirmation: string
}

export interface RefreshTokenRequest {
  refresh_token: string
}

export interface ForgotPasswordRequest {
  email: string
}

export interface VerifyResetOtpRequest {
  email?: string
  token?: string
  otp: string
}

export interface ResetPasswordRequest {
  token: string
  email: string
  password: string
  password_confirmation: string
}

export interface LogoutRequest {
  device_token?: string
}

// Local storage keys
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'tf_access_token',
  ACCESS_TOKEN_EXPIRES_AT: 'tf_access_token_expires_at',
  REFRESH_TOKEN: 'tf_refresh_token',
  REFRESH_TOKEN_EXPIRES_AT: 'tf_refresh_token_expires_at',
  USER: 'tf_user',
} as const
